<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-28 13:54:54
 * @LastEditTime: 2020-12-18 09:39:13
--> 
<template>
  <dl class="physical-list-container">
    <dd class="item" v-for="(item,index) in list" :key="index">
      <!-- 多选checkbox -->
      <label class="check-item" v-if="isChecked">
        <input type="checkbox" name="selectitem" :value="item.alias" v-model="selectValue" />
        <span class="icon"></span>
      </label>

      <div class="item-content" @click="handleToDetail(item)">
        <span class="commission-tag" :class="[item.is_directional === '1' ? 'dx' : item.is_activity_valid === '1' ? 'xs':'']"></span>
        <div class="img-box">
          <img v-lazy="item.our_pic_url" alt="">
          <div class="sales" v-if="returnSales(item) > 0">月销量：{{returnSales(item)}}</div>
          
          <!-- <div class="tag-box">
            <span class="tag-item hot"></span>
          </div> -->
        </div>
        <div class="inner">
          <div>
            <div class="title ellipsis-2">{{item.title}}</div>
            <div class="store-box">
              <i class="store-logo" :class="[`icon_${item.source}`]"></i>
              <span class="label">店铺</span>
              <div class="store-name">{{item.shop_name}}</div>
            </div>
          </div>
          <div>
            <div class="coupon-box" v-if="item.coupon > 0">
              <span class="txt">¥{{item.coupon}}</span>
              <span class="label">券 </span>
            </div>
            <div class="price-area" v-if="source === 'selected'">
              <div class="price-box">
                <span class="label">已获佣金:</span>
                <span class="yuan"> ¥ </span>
                <!-- <nr-amount :value="item.all_distribution_pay" has-separator class="number" /> -->
                <nr-amount value="0.0000" has-separator class="number" />
              </div>
              <div class="price-box">
                <span class="label">已卖出: </span>
                <span class="number">{{item.all_pay_count}}</span>
                <span class="yuan"></span>
              </div>
            </div>
            <div class="price-area" v-else>
              <div class="price-box">
                <span class="label">券后价:</span>
                <span class="yuan">¥</span>
                <nr-amount :value="item.final_price" has-separator class="number" />
              </div>
              <div class="price-box">
                <span class="label">佣金:</span>
                <span class="number">{{round((item.source === '2' || item.source === '4' ? item.channel_media_distribution_proportion : item.final_media_distribution_proportion) * 100)}}</span>
                <span class="yuan">％</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dd>
    <Empty iconType="2" title="暂无数据" v-if="!list.length" />
  </dl>
</template>

<script>
import { round } from '@/utils'

export default {
  data() {
    return {
      selectValue: []
    }
  },
  props: {
    list: {
      type: Array,
      default: ()=>[]
    },
    isNewWindow: {
      type: Boolean,
      default: false
    },
    isChecked: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: ''
    }
  },
  methods: {
    round,
    // 清空已选择 item
    clearSelectValue() {
      this.selectValue = []
    },
    //返回已选择 item
    getSelectValue() {
      return this.selectValue;
    },
    //返回销量
    returnSales(item) {
      return (item.source === '2' || item.source === '4') ? item.volume : item.total_sold_num;
    },
    //去详情
    handleToDetail(item) {
      
      if(!this.isNewWindow) {
        this.$router.push({
          name: 'physicalDetail',
          params: {
            id: item.alias
          },
          query: {
            category: item.our_category_id
          }
        })
      }else{
        let { href } = this.$router.resolve({
          name: 'physicalDetail',
          params: {
            id: item.alias
          },
          query: {
            category: item.our_category_id
          }
        })
        let newWindow = window.open('_blank');
        newWindow.location = href
      }
    }
  }
}
</script>

<style lang="scss">
.physical-list-container{
  margin-top: 12px;

  .item{
    display: flex;
    padding: 24px 32px;
    box-sizing: border-box;
    align-items: center;
  }
  .check-item {
    width: 32px;
    height: 32px;
    margin-right: 30px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    .icon {
      display: block;
      width: 100%;
      height: 100%;
      border: 1px solid #e1e2e5;
      border-radius: 50%;
      box-sizing: border-box;
    }
    input {
      font-size: 300%;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;

      &:checked + .icon {
        border: none;
        background: url("../../../assets/imgs/icon_selected.svg") no-repeat center;
        background-size: 100%;
      }
    }
  }
  .item-content{
    width: 0;
    flex: 1;
    display: flex;
    cursor: pointer;
    position: relative;

    .commission-tag{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;

      &.dx{
        top: -4px;
        left: -4px;
        width: 80px;
        height: 80px;
        background: url('../../../assets/imgs/icon_physical_dx.svg') no-repeat;
        background-size: 100% auto;
      }
      &.xs{
        top: 8px;
        left: -6px;
        width: 140px;
        height: 40px;
        background: url('../../../assets/imgs/icon_physical_xs.svg') no-repeat;
        background-size: 100% auto;
      }
    }
    .img-box{
      width: 244px;
      height: 244px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      margin-right: 16px;
      border: 1px solid #E1E1E6;

      img{
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .sales{
      padding: 0 22px 0 16px;
      line-height: 48px;
      font-size: 23px;
      color: #fff;
      border-radius: 0 28px 0px 0px;
      background: rgba($color: #262626, $alpha: .7);
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
    }
    .tag-box{
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;

      .tag-item{
        width: 54px;
        height: 32px;
        margin-right: 8px;

        &.new{
          background: url('../imgs/icon_new.svg') no-repeat;
          background-size: contain;
        }
        &.hot{
          background: url('../imgs/icon_hot.svg') no-repeat;
          background-size: contain;
        }
      }
    }
    .inner{
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .title{
      color: #262626;
      line-height: 1.3;
      font-size: 28px;
      font-weight: bold;
    }
    .store-box{
      display: flex;
      align-items: center;
      color: #595959;
      margin-top: 16px;
      font-size: 24px;

      .icon-youzan{
        color: #ee2200;
        font-size: 24px;
        line-height: 1;
      }
      .label{
        flex-shrink: 0;
        display: inline-block;
        position: relative;

        &::after{
          content: '';
          display: inline-block;
          width: 1px;
          height: 16px;
          margin: 0 16px;
          background-color: #BFBFBF;
        }
      }
    }
    .store-logo{
      width: 28px;
      height: 28px;
      display: inline-block;
      margin-right: 8px;
      
      &.icon_1{
        background: url('../../../assets/imgs/icon_youzan.svg') no-repeat center;
        background-size: contain
      }
      &.icon_2,&.icon_4{
        background: url('../../../assets/imgs/icon_taobao.svg') no-repeat center;
        background-size: contain;
      }
      &.icon_3{
        background: url('../../../assets/imgs/icon_jd.svg') no-repeat center;
        background-size: contain;
      }
      &.icon_5 {
        background: url('../../../assets/imgs/icon_pdd.svg') no-repeat center;
        background-size: contain;        
      }
    }
    .store-name{
      width: 0;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .price-area{
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
    .price-box{
      font-size: 28px;

      .label{
        font-size: 24px;
        color: #949999;
      }
      .yuan{
        font-size: 20px;
        color: $primary-color;
      }
      .number{
        font-weight: bold;
        color: $primary-color;
      }
    }
  }
}
</style>